import { styled } from '@mui/material'

interface ProgressBarProps {
  value: number
  max?: number
}

const ProgressBar = styled('progress')<ProgressBarProps>(({ theme, value, max }) => ({
  // set default appereance accros browsers
  appearance: 'unset',
  // disable border in Firefox
  border: 'none',

  width: '100%',
  height: 4,

  backgroundColor: 'white',
  boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.25) inset',

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },

  '&::-webkit-progress-bar': {
    background: 'transparent',
  },

  '&::-webkit-progress-value': {
    transition: 'width 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
    backgroundColor: theme.palette.primary.main,
  },

  '&::-moz-progress-bar': {
    backgroundColor: theme.palette.primary.main,
  },
}))

ProgressBar.defaultProps = {
  max: 100,
  value: 0,
}

export default ProgressBar
